import React, { useState } from "react";
import { LeadViewDetailsViewProps } from "./campaign-view-details-view.props";
import LeadViewDetailsViewFullInfo from "./campaign-view-details-view-full-info/campaign-view-details-view-full-info";
import LeadViewEditViewFullInfo from "../campaign-view-details-edit/campaign-view-edit-view-full-info/campaign-view-edit-view-full-info";
import { AlertComponent } from "../../../../../common/components";
import "./campaign-view-details-view.scss";

const LeadViewDetailsView: React.FC<LeadViewDetailsViewProps> = ({
  campaignDetails,
  setLoading,
  selectedCampaignId,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  uploadedImageFile,
  removeImage,
  fetchCampaignDetails,
  onCampaignNameUpdate,
  resetImageUpload,
  permissions,
}) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleCancelUpdate = () => {
    setViewFullInfoOpen(false);
    fetchCampaignDetails();
  };

  return (
    <div className="campaign-list-view-details-view-box">
      {viewFullInfoOpen ? (
        <LeadViewEditViewFullInfo
          setViewFullInfoOpen={setViewFullInfoOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          campaignDetails={campaignDetails}
          selectedCampaignId={selectedCampaignId}
          handleCancelUpdate={handleCancelUpdate}
          setAlertOpen={setAlertOpen}
          setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setLoading={setLoading}
          uploadedImage={uploadedImage}
          uploadedImageFile={uploadedImageFile}
          removeImage={removeImage}
          onCampaignNameUpdate={onCampaignNameUpdate}
          resetImageUpload={resetImageUpload}
        />
      ) : (
        <LeadViewDetailsViewFullInfo
          setViewFullInfoOpen={setViewFullInfoOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          campaignDetails={campaignDetails}
          permissions={permissions}
        />
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default LeadViewDetailsView;
